export default function useWebview() {
  const isWebview = window.navigator.userAgent.toLowerCase().includes('photobucketapp')

  return {
    isWebview
  }
}
